import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["prompt"]

  connect() {
    if (!("Notification" in window)) return
    if (Notification.permission === "default") {
      this.promptTarget.classList.remove("hidden")
    }
  }

  request() {
    Notification.requestPermission().then(() => {
      this.promptTarget.classList.add("hidden")
    })
  }
}
